export default __webpack_public_path__ + "static/media/p3.31828795.png";